module.exports = __webpack_public_path__ + "static/img/video1.36f84b45.png";